export default __webpack_public_path__ + "static/media/arcade.187b7c26.png";